import React, { useState } from 'react';
import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
  Breadcrumb,
  BreadcrumbWithIcons,
  Pagination,
  SimplePagination,
  Stack,
} from '@/components/ui';
import { CodeBlock } from '../CodeBlock';
import { SectionWrapper } from '../SectionWrapper';

export function NavigationSection() {
  const [activeTab, setActiveTab] = useState('overview');
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <SectionWrapper title="Navigation Components">
        {/* Tabs */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Tabs</h3>
          <Tabs value={activeTab} onValueChange={setActiveTab}>
            <TabsList>
              <TabsTrigger value="overview">Overview</TabsTrigger>
              <TabsTrigger value="details">Details</TabsTrigger>
              <TabsTrigger value="settings">Settings</TabsTrigger>
              <TabsTrigger value="disabled" disabled>Disabled</TabsTrigger>
            </TabsList>
            <TabsContent value="overview" className="p-4 bg-muted rounded">
              <p>Overview content goes here. You can put any content inside tabs.</p>
            </TabsContent>
            <TabsContent value="details" className="p-4 bg-muted rounded">
              <p>Details content goes here. Each tab can have different content.</p>
            </TabsContent>
            <TabsContent value="settings" className="p-4 bg-muted rounded">
              <p>Settings content goes here. Tabs help organize related content.</p>
            </TabsContent>
          </Tabs>
          <CodeBlock>
{`<Tabs value={activeTab} onValueChange={setActiveTab}>
  <TabsList>
    <TabsTrigger value="overview">Overview</TabsTrigger>
    <TabsTrigger value="details">Details</TabsTrigger>
    <TabsTrigger value="settings">Settings</TabsTrigger>
  </TabsList>
  <TabsContent value="overview">
    Overview content goes here.
  </TabsContent>
  <TabsContent value="details">
    Details content goes here.
  </TabsContent>
  <TabsContent value="settings">
    Settings content goes here.
  </TabsContent>
</Tabs>`}
          </CodeBlock>
        </div>

        {/* Breadcrumb */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Breadcrumb</h3>
          <Stack spacing={4}>
            <Breadcrumb
              items={[
                { label: 'Home', href: '/dashboard' },
                { label: 'Products', href: '/products' },
                { label: 'Electronics', href: '/products/electronics' },
                { label: 'Laptop', current: true },
              ]}
            />
            <BreadcrumbWithIcons
              items={[
                { label: 'Home', href: '/dashboard' },
                { label: 'Settings', href: '/settings' },
                { label: 'Profile', current: true },
              ]}
            />
          </Stack>
          <CodeBlock>
{`<Breadcrumb
  items={[
    { label: 'Home', href: '/dashboard' },
    { label: 'Products', href: '/products' },
    { label: 'Electronics', href: '/products/electronics' },
    { label: 'Laptop', current: true },
  ]}
/>

<BreadcrumbWithIcons
  items={[
    { label: 'Home', href: '/dashboard' },
    { label: 'Settings', href: '/settings' },
    { label: 'Profile', current: true },
  ]}
/>`}
          </CodeBlock>
        </div>

        {/* Pagination */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Pagination</h3>
          <Stack spacing={4}>
            <div>
              <p className="text-sm text-muted-foreground mb-2">Standard Pagination</p>
              <Pagination
                currentPage={currentPage}
                totalPages={10}
                onPageChange={setCurrentPage}
              />
            </div>
            <div>
              <p className="text-sm text-muted-foreground mb-2">Simple Pagination</p>
              <SimplePagination
                currentPage={currentPage}
                totalPages={10}
                onPageChange={setCurrentPage}
              />
            </div>
          </Stack>
          <CodeBlock>
{`<Pagination
  currentPage={currentPage}
  totalPages={10}
  onPageChange={setCurrentPage}
/>

<SimplePagination
  currentPage={currentPage}
  totalPages={10}
  onPageChange={setCurrentPage}
/>`}
          </CodeBlock>
        </div>
    </SectionWrapper>
  );
}
